// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Audience shortcuts */
.contact_routes__24pT6 {
  display: grid;
  gap: var(--space-3);
  grid-template-columns: repeat(auto-fit, minmax(min(16rem, 100%), 1fr));
}
.contact_route__wt59U {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 0.25rem var(--space-4);
  padding: var(--space-5);
  border: 1px solid var(--color-border-on-dark);
  border-radius: var(--radius-md);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.02));
  backdrop-filter: blur(10px);
  color: #fff;
  text-decoration: none;
  transition: border-color var(--dur-fast) ease, transform var(--dur) var(--ease-out),
    background var(--dur-fast) ease;
}
.contact_route__wt59U:hover,
.contact_route__wt59U:focus-visible {
  color: #fff;
  border-color: var(--kur-gold);
  background: linear-gradient(180deg, rgba(255, 215, 0, 0.1), rgba(255, 255, 255, 0.02));
  transform: translateY(-3px);
}
.contact_routeLabel__uqboL {
  font-size: 1.2rem;
  font-weight: 500;
  white-space: nowrap;
}
.contact_routeText__H-\\+Fs {
  grid-column: 1;
  font-size: 0.925rem;
  line-height: 1.5;
  color: var(--color-text-muted-on-dark);
}
.contact_routeArrow__av2DX {
  grid-column: 2;
  grid-row: 1 / span 2;
  align-self: center;
  font-size: 1.4rem;
  color: var(--kur-gold);
  transition: transform var(--dur-fast) var(--ease-out);
}
.contact_route__wt59U:hover .contact_routeArrow__av2DX {
  transform: translateX(5px);
}
@media (prefers-reduced-motion: reduce) {
  .contact_route__wt59U:hover,
  .contact_route__wt59U:focus-visible {
    transform: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/CONTACT_PAGE/contact.module.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,sEAAsE;AACxE;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,0CAA0C;EAC1C,2BAA2B;EAC3B,uBAAuB;EACvB,6CAA6C;EAC7C,+BAA+B;EAC/B,yFAAyF;EAEzF,2BAA2B;EAC3B,WAAW;EACX,qBAAqB;EACrB;mCACiC;AACnC;AACA;;EAEE,WAAW;EACX,6BAA6B;EAC7B,sFAAsF;EACtF,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,qDAAqD;AACvD;AACA;EACE,0BAA0B;AAC5B;AACA;EACE;;IAEE,eAAe;EACjB;AACF","sourcesContent":["/* Audience shortcuts */\n.routes {\n  display: grid;\n  gap: var(--space-3);\n  grid-template-columns: repeat(auto-fit, minmax(min(16rem, 100%), 1fr));\n}\n.route {\n  position: relative;\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 0.25rem var(--space-4);\n  padding: var(--space-5);\n  border: 1px solid var(--color-border-on-dark);\n  border-radius: var(--radius-md);\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.02));\n  -webkit-backdrop-filter: blur(10px);\n  backdrop-filter: blur(10px);\n  color: #fff;\n  text-decoration: none;\n  transition: border-color var(--dur-fast) ease, transform var(--dur) var(--ease-out),\n    background var(--dur-fast) ease;\n}\n.route:hover,\n.route:focus-visible {\n  color: #fff;\n  border-color: var(--kur-gold);\n  background: linear-gradient(180deg, rgba(255, 215, 0, 0.1), rgba(255, 255, 255, 0.02));\n  transform: translateY(-3px);\n}\n.routeLabel {\n  font-size: 1.2rem;\n  font-weight: 500;\n  white-space: nowrap;\n}\n.routeText {\n  grid-column: 1;\n  font-size: 0.925rem;\n  line-height: 1.5;\n  color: var(--color-text-muted-on-dark);\n}\n.routeArrow {\n  grid-column: 2;\n  grid-row: 1 / span 2;\n  align-self: center;\n  font-size: 1.4rem;\n  color: var(--kur-gold);\n  transition: transform var(--dur-fast) var(--ease-out);\n}\n.route:hover .routeArrow {\n  transform: translateX(5px);\n}\n@media (prefers-reduced-motion: reduce) {\n  .route:hover,\n  .route:focus-visible {\n    transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"routes": `contact_routes__24pT6`,
	"route": `contact_route__wt59U`,
	"routeLabel": `contact_routeLabel__uqboL`,
	"routeText": `contact_routeText__H-+Fs`,
	"routeArrow": `contact_routeArrow__av2DX`
};
export default ___CSS_LOADER_EXPORT___;
